import React from 'react';
import { useSelector } from 'react-redux';
import {
  trEnv, Message,
} from 'ion-lib';
import i18next from 'i18next';

const compareGkWith = (gk, value) => parseInt(gk.value, 10) === value;

const ZuersPruefung = () => {
  const gk = useSelector((state) => state.daten.wagnis.gk);
  const showAlert = (compareGkWith(gk, 0) || compareGkWith(gk, 4)) && (trEnv.istVGH || trEnv.istOEVB);

  return (trEnv.stationaer && showAlert) && (
    <Message
      show
      dismissible={false}
      text={i18next.t(`produktvergleich.zusatz.naturgefahren_alert_gk${gk.value}_stat`)}
      className="mt-n1 w-100"
    />
  );
};

export default ZuersPruefung;
